module.exports = __webpack_public_path__ + "img/oliver-borner5.1c76e3b9.jpg";